module.exports = __webpack_public_path__ + "media/Block.db553130.mp3";